import React from "react";
import "./HomeserviceCard.css";

const HomeserviceCard = ({ Icon, ServiceName, desc }) => {
  return (
    <div className="HomeserviceCardContainer">
      <span className="HSCardIcon">
        <Icon />
      </span>
      <span className="HSCardSerName">{ServiceName}</span>
      <span className="HSCardSerPara">{desc}</span>
    </div>
  );
};

export default HomeserviceCard;
